import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer";
import date from "../../Assets/Vendor/Date.png";
import office from "../../Assets/Vendor/Office.png";
import keys from "../../Assets/Vendor/Keys.png";
import landingImage4 from "../../Assets/Home/landingImage4.png";
import Navbar from "../../Components/Navbar";
import { useSelector } from "react-redux";
import { roles } from "../../Utils/constants";
import Swal from "sweetalert2";

export default function Vendor() {
  const { value: isLoggedIn, role } = useSelector((state) => state.user);
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <div className="text-white text-2xl py-8 lg:px-12 sm:px-12 px-4 flex items center bg-[#2EBAA3]">
        <span>Vendor</span>
      </div>
      {/* Vendor Landing Page */}
      <div>
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="flex flex-col-reverse lg:flex-row text-center mx-4 md:mx-12"
        >
          <div className="flex flex-col space-y-10 max-w-screen-lg py-24">
            <div className="text-center lg:text-start">
              <span
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "42px",
                  lineHeight: "55px",
                }}
              >
                ProLegion for Vendors
              </span>
            </div>
            <div
              className="text-center font-extralight lg:text-justify"
              style={{
                fontSize: "20px",
                lineHeight: "27px",
              }}
            >
              Prolegion offers a platform for vendors to manage their clients,
              consultants, timesheets, invoices, jobs, and projects. Based on
              the approved timesheets, vendors may quickly create jobs for their
              clients, manage timesheets, and produce invoices for their
              consultants. Prolegion also allows suppliers to network with one
              another in order to share resources and jobs.
            </div>
            <div className="flex lg:justify-start justify-center">
              <button
                className="w-[191px] h-[50px] hover:h-[53px] hover:w-[195]"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  if (isLoggedIn) {
                    if (role === roles.vendor) navigate("/dashboard");
                    else
                      Swal.fire(
                        "",
                        `You are already logged in as a ${role.toLowerCase()}<br>To try the vendor section, please logout first`,
                        "info"
                      );
                  } else navigate("/signup");
                }}
              >
                <button
                  style={{
                    border: "2px solid #139588",
                    borderRadius: "25px",
                    color: "#139588",
                  }}
                  className="w-[191px] h-[50px] hover:h-[53px] hover:w-[195] mt-[2px] shadow-md hover:shadow-lg"
                >
                  Try for free
                </button>
              </button>
            </div>
          </div>
          <div className="mt-3 lg:ml-20">
            <img
              alt="landingImage"
              className="object-contain"
              src={landingImage4}
            />
          </div>
        </div>
      </div>
      {/* How we serve */}
      <div className="font-[Roboto] text-3xl lg:text-left text-center lg:px-12 py-8">
        How We Serve You
      </div>
      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row-reverse justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-3/5 lg:ml-10 lg:pr-40">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Manage your IT Clients & Jobs
            </div>
            <div className="lg:ml-12 font-extralight space-y-4 lg:text-justify text-center text-[18px] leading-[27px]">
              Vendors can easily manage their IT clients and consultants using
              our IT service platform. Suppliers can monitor compliance
              requirements, track client and consultant performance indicators,
              and manage contracts and project timeframes. Our technology
              centralises all vendor interactions, allowing for real-time
              collaboration with clients and consultants. Our timesheet
              monitoring tool allows vendors to monitor billable hours and
              ensure precise payment, while our invoice management system allows
              them to generate invoices and follow payment progress. Vendors can
              use our platform to better communication and cooperation with
              customers and consultants, guarantee regulatory compliance, and
              achieve greater performance from their IT projects. Overall, our
              platform streamlines vendor management processes, allowing
              suppliers to concentrate on providing high-quality IT services.
            </div>
          </div>
          <div className="flex justify-center max-h-[400px] lg:w-2/5">
            <img alt="office" className="px-4 sm:px-0 object-contain" src={office} />
          </div>
        </div>
      </div>
      {/* Collaboration and Efficiency */}
      <div
        style={{ display: "flex", justifyContent: "center" }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-2/3">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Increased Collaboration and Efficiency
            </div>
            <div className="lg:mr-12 space-y-4 font-extralight lg:text-justify text-center text-[18px] leading-[27px]">
              <p>
                The platform provided by Prolegion enables vendors to
                collaborate more efficiently with their clients and consultants.
                Consultants may submit timesheets and receive payments on time,
                while vendors can simply exchange project details, timesheets,
                and bills with their clients. This better collaboration can
                assist suppliers in developing deeper relationships with their
                clients and consultants, potentially leading to more business
                prospects in the future.
              </p>

              <p>
                Our vendor management solution simplifies the vendor management
                process, allowing vendors to manage their workload more
                efficiently. Vendors can save time and boost productivity by
                managing clients, consultants, timesheets, invoicing, jobs, and
                projects all on one platform.
              </p>
            </div>
          </div>
          <div className="flex justify-center lg:w-1/3 max-h-[450px]">
            <img alt="date" className="px-4 sm:px-0 object-contain" src={date} />
          </div>
        </div>
      </div>
      {/* Pay vendors */}
      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row-reverse justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-3/5">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Resource access and increased job opportunity
            </div>
            <div className="lg:ml-12 space-y-4 font-extralight lg:text-justify text-center text-[18px] leading-[27px]">
              Vendors receive access to more resources when they connect with
              other vendors through Prolegion. By eliminating the need to engage
              extra staff or contractors, this can save time and money.
              Prolegion sellers might enhance their job chances by exchanging
              jobs with other vendors. If a vendor cannot accomplish a project
              on their own, they can collaborate with other vendors who have the
              requisite skills and resources. This can result in additional work
              for all parties involved as well as stronger vendor relationships.
            </div>
          </div>
          <div className="flex justify-center lg:w-2/5 max-h-[400px]">
            <img alt="securekeys" className="px-4 sm:px-0 object-contain" src={keys} />
          </div>
        </div>
      </div>
      {/* Register Button */}/
      <div className="py-16">
        <div className="flex justify-center">
          <button
            onClick={() => navigate(isLoggedIn ? "/dashboard" : "/signup")}
            style={{
              width: "191px",
              height: "50px",
              background: "#139588",
              borderRadius: "25px",
              color: "white",
            }}
          >
            Register
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
